import { parse } from 'cookie';

export const parseCookies = () => {
  if (typeof document === 'undefined') {
    return {};
  }

  return parse(document.cookie);
};
